var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _vm.errorMessageLogs
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.errorMessageLogs) +
                          "\n              "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.sucessStatus
                  ? _c("div", { staticClass: "alert alert-success" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.sucessStatus) +
                          "\n              "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("h3", [
                  _vm._v("\n                二段階認証設定\n              ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("SMS認証の設定を変更して電話番号を入力してください。")
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "none-list" }, [
                  _c("li", [
                    _c("label", { staticClass: "clearfix" }, [
                      _c(
                        "div",
                        {
                          staticClass: "profile-info-name",
                          staticStyle: {
                            width: "156px",
                            "text-align": "left",
                            color: "#000",
                            "padding-left": "0px"
                          }
                        },
                        [_vm._v("SMS認証")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-info-value" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInfor.isMfaSms,
                              expression: "userInfor.isMfaSms"
                            }
                          ],
                          staticClass: "ace ace-switch ace-switch-4",
                          attrs: {
                            name: "switch-field-1",
                            disabled: _vm.isMfa === "false",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.userInfor.isMfaSms)
                              ? _vm._i(_vm.userInfor.isMfaSms, null) > -1
                              : _vm.userInfor.isMfaSms
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.userInfor.isMfaSms,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.userInfor.isMfaSms = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.userInfor.isMfaSms = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.$set(_vm.userInfor, "isMfaSms", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", {
                      staticClass: "error_m",
                      attrs: { id: "phonenumber_error" }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "clearfix" }, [
                      _c(
                        "div",
                        {
                          staticClass: "profile-info-name",
                          staticStyle: {
                            width: "156px",
                            "text-align": "left",
                            color: "#000",
                            "padding-left": "0px"
                          }
                        },
                        [_vm._v("電話番号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "profile-info-value",
                          staticStyle: { width: "70%" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.userInfor.phoneNumber,
                                expression: "userInfor.phoneNumber"
                              }
                            ],
                            staticClass: "input form-control input-sm",
                            attrs: {
                              id: "phonenumber",
                              type: "text",
                              disabled: !_vm.allowSubmit
                            },
                            domProps: { value: _vm.userInfor.phoneNumber },
                            on: {
                              blur: function($event) {
                                _vm.validateBeforeSubmit(2)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.userInfor,
                                  "phoneNumber",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info",
                        staticStyle: {
                          "padding-left": "20px",
                          "padding-right": "20px"
                        },
                        attrs: {
                          type: "submit",
                          disabled: _vm.isMfa === "false"
                        },
                        on: { mousedown: _vm.submitConfig }
                      },
                      [_vm._v("\n                  登録\n                  ")]
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [_vm._v("設定")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [_c("h3", [_vm._v("設定")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "profile-info-value",
          staticStyle: { width: "75%", "padding-top": "0px" }
        },
        [
          _c("span", [
            _vm._v(
              " 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。 "
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85027fa8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85027fa8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/Configuration.vue
// module id = null
// module chunks = 